/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentLink/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconExternalLink from 'DesignSystem/Svgs/TysiaIconExternalLink/index'



/** @type {import('Simple/types.js').View} */
export default function PaymentLink({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/AppliedPayment/PaymentLink"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 marginLeft={dtSpaceXxxs}
 marginTop={3}
 height="auto"
 paddingLeft={0}
 paddingRight={0}
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconExternalLink
{...childProps}
  viewPath={`${viewPath}/TysiaIconExternalLink`}
 fill={dtColorsWhite}
 width={13}
 height={13}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}